import _ from 'lodash'; // load lodash here
import RegisterComponent from './components/frontend/RegisterComponent.vue';
import AnnouncementComponent from './components/frontend/AnnouncementComponent.vue';
import ErrorPageComponent from './components/ErrorPageComponent.vue';

export const routes = [
    { path: '/', component: RegisterComponent },
    { path: '/:Announcement_id', component: AnnouncementComponent },
    { path: '*', component: ErrorPageComponent, name: 'errorPage' }
];



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-routes.js